<template>
  <div>
    <div>
      <p class="bold">חלון מספר 1 מתוך 3</p>
    </div>
    <div>
      <p><b>שם המשרד</b></p>
      <history-companies-search-box ref="history_companies_search_box" @selected="selectHistoryCompany"></history-companies-search-box>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-faded': selected_history_company == undefined, 'is-loading': is_loading }"
        class="button is-info"
        >המשך לשלב הבא</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import HistoryCompaniesSearchBox from '@/components/HistoryCompaniesSearchBox'
export default {
  name: 'create-company-step-one',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      selected_history_company: undefined
    }
  },
  methods: {
    selectHistoryCompany (history_company) {
      this.selected_history_company = history_company
    },
    submit () {
      if (this.selected_history_company == undefined) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י history_company או צור/י חדש' })
        return
      }
      this.is_loading = true
      this.continueToStepTwo()
    },
    continueToStepTwo () {
      this.create({ desginator: 'create-company-step-two',
        component_name: 'CreateCompanyStepTwo',
        ignore_escape_button: true,
        history_company: this.selected_history_company,
        modal_title: 'Create new Company'
      })
      this.payload.is_fixed = false
      this.remove(this.payload)
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    HistoryCompaniesSearchBox
  }
}
</script>
